export default {
  title: 'Productos impresos personalizados',
  fields: {
    name: 'Nombre',
    format: 'Tipo de producto',
  },
  buttons: {
    upload_product: 'Iniciar proceso de carga',
    preview: 'Vista previa',
    edit: 'Editar',
  },
};
